<template>
  <div>
    <billboard />
    <upcomingWidget :list="2" :highlight="true" />
    <upcomingWidget :list="2" />
  </div>

</template>

<script>
import upcomingWidget from '@/components/sportsbook/widget/upcoming';
import billboard from "../widget/billboard";
import fixtureSlider from "./widget/fixtureSlider";
export default {
  name: 'promotionDetail',
  components: {fixtureSlider, billboard, upcomingWidget},
  data () {
    return {
      msg: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/sportsbook/fixtureHome.vue